import React from 'react';
import Fade from 'react-reveal/Fade';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ProjectSection from '../components/ProjectSection';
import ContactBanner from '../components/ContactBanner';

function Home() {
  return (
    <div>
      <Fade>
        <HeroSection />
      </Fade>
      <Fade>
        <AboutSection />
      </Fade>
      <Fade>
        <ProjectSection />
      </Fade>
      <Fade>
        <ContactBanner />
      </Fade>
    </div>
  );
}

export default Home;
